import { useState, useEffect } from 'react';
import Stepper from './components/Stepper';
import StepperControl from './components/StepperControl';
import { UseContextProvider } from './contexts/StepperContext';
import CreateEvent from './components/steps/createEvent';
import UploadFile from './components/steps/UploadFile';
import EventConfig from './components/steps/EventConfig';
import NonWorkingTime from './components/steps/NonWorkingTime';
import InteractionModeSelector from './components/steps/InteractionModeSelector';
import InitialPrompt  from './components/steps/InitialPrompt';
import Card from 'components/card';
import { addEvent } from '../../../redux/eventSlice';
import { RootState } from '../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch } from '../../../redux/store';
import { fetchEvents } from '../../../redux/eventSlice';
import { FaTrash } from 'react-icons/fa';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

import { Mixpanel } from '../../../mixpanel/MixpanelTrack';
import { EVENTS } from  '../../../mixpanel/mixpanelEvent';
import { v4 as uuidv4 } from 'uuid';
const getCurrentDateFormatted = () =>{
  const now = new Date();

  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0'); // January is 0!
  const year = now.getFullYear();

  return `${day}-${month}-${year}`;
}
// New StepperTabs component for direct navigation between steps
const StepperTabs = ({
  steps,
  currentStep,
  setCurrentStep,
}: {
  steps: { stepNo: number }[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
}) => {
  return (
    <div className="flex w-full border-b">
      {steps.map((step) => (
        <div
          key={step.stepNo}
          className={`flex-1 text-center py-3 cursor-pointer relative ${
            currentStep === step.stepNo
              ? 'text-blue-600 font-semibold'
              : 'text-gray-600'
          }`}
          onClick={() => setCurrentStep(step.stepNo)}
        >
          Step {step.stepNo}
          {currentStep === step.stepNo && (
            <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-600" />
          )}
        </div>
      ))}
    </div>
  );
};

const CreateEditEvent = () => {
  const [open, setOpen] = useState(false);


  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams();
  const [newEventId] = useState(() => uuidv4());
  console.log(newEventId);
  const event = useSelector((state: RootState) => state.event);

  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const steps = [
    { stepNo: 1 },
    { stepNo: 2 },
    { stepNo: 3 },
    { stepNo: 4 },
    { stepNo: 5 },
    { stepNo: 6 },
  ];

  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  useEffect(() => {
    console.log(event);
    if (event.data !== null && id) {
      const eventData = event.data.filter((eventItem) => eventItem.eventId === id)[0];
      console.log(eventData);
      setSelectedEvent(eventData);
    }
  }, [id, event.data]);

  const displayStep = (step: {
    stepNo: number;
    highlighted?: boolean;
    selected?: boolean;
    completed?: boolean;
  }) => {
    switch (step.stepNo) {
      case 1:
        return id ? <CreateEvent eventObject={selectedEvent} /> : <CreateEvent />;
      case 2:
        return id ? <UploadFile eventObject={selectedEvent} eventId={newEventId} /> : <UploadFile eventId={newEventId}  />;
      case 3:
        return id ? <EventConfig eventObject={selectedEvent} /> : <EventConfig />;
        case 4:
         return id ? <NonWorkingTime eventObject={selectedEvent} /> : <NonWorkingTime />;
         case 5:
          return id ? <InteractionModeSelector eventObject={selectedEvent} /> : <InteractionModeSelector />;
          case 6:
            return id ? <InitialPrompt eventObject={selectedEvent} /> : <InitialPrompt />;
      default:
    }
  };

  const handleClick = (direction: string) => {
    setLoading(true);
    const email = localStorage.getItem('email');

    if(direction === 'submit') {
      const eventData = {
        ...event.payload,
        user_email:email,
        meetingLink: `${event.payload.meetingLink}/${event.payload.meetingLink1}/${event.payload.meetingLink2}`,
        eventDate: getCurrentDateFormatted(),
        eventId:id ? id : newEventId,
      }
      console.log(eventData);
      dispatch(addEvent(eventData));
      toast.success('Event created successfully');
      setTimeout(() => {
        dispatch(fetchEvents());

      },100);
      setTimeout(() => {
        setLoading(false);
      },1000);
      
      // Mixpanel.track(EVENTS.event_create_edit, { requestEmail: email });

      navigate('/events/whatsapp-phone-numbers-list');

    }else {
      let newStep = currentStep;
      direction === 'next' ? newStep++ : newStep--;
      newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
      setTimeout(() => {
        setLoading(false);
      },1000);
    }

  };
  const onCloseModal = () => setOpen(false);
  const handleOkAction = () => {
    setOpen(false);
    // navigate('/events');
  }
  return (
    <div className="mt-3 h-full w-full">
        <Modal open={open} onClose={onCloseModal} 
          aria-labelledby="my-modal-title" 
          aria-describedby="my-modal-description" center>
            <div className="p-4">
              <h2>Are you sure want to delete Event ?</h2>
              <div className="flex justify-end mt-4">
                  <button 
                    onClick={onCloseModal} 
                    className="px-4 py-2 border rounded mr-2">
                    Cancel
                  </button>
                  <button 
                    onClick={handleOkAction} // Replace with your "OK" action handler
                    className="px-4 py-2 bg-blue-500 text-white rounded">
                    YES
                  </button>
                </div>
            </div>
        </Modal>
      <div className="w-full rounded-[10px] bg-gradient-to-br md:h-[5px] mt-0 pt-0" />
      <div className="w-md:2/3 mx-auto h-[600px] md:px-3 3xl:w-7/12 mt-0 pt-0">

        <Card extra={'h-full mx-auto pb-0'} >
          {/* Tab Header for direct navigation */}
          <StepperTabs
            steps={steps}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
          <div className="rounded-[20px] max-h-[600px] overflow-auto w-full">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {/* navigation button */}

          <StepperControl
            handleClick={handleClick}
            buttonLoading={isLoading}
            currentStep={currentStep}
            steps={steps}
          />
        </Card>
      </div>
      <div>
    

    </div>
    </div>
  );
};

export default CreateEditEvent;
